export enum TimeDisplayFormat {
    ClientDefault = 0,
    Hour12 = 1,
    Hour24 = 2,
}

